import { computed } from "vue"
import { useStore } from "vuex"

export default {
    name: "DeleteGlobalProfileOverlay",
    setup() {
        const store = useStore()
        const userProfileId = computed(() => store.state.main.page_overlay_content_data.userProfileId)
        const privacyPolicy = computed(() => store.state.main.page_overlay_content_data.privacyPolicy)
        const isSubmitting = computed(() => store.state.main.is_submitting)

        const getLabel = (labelKey) =>
            store.getters['labels/getLabel']({
                labelCollection: 'DeleteGlobalProfileOverlay',
                labelKey
            })

        const closeOverlay = () => {
            store.dispatch('main/closePageOverlay')
        }

        const submit = async () => {
            store.dispatch('main/deleteUserProfile', {
                userProfileId: userProfileId.value, 
                body: {
                    isCancerforumSoftDelete: true
                }
            })
            .then((redirectUrl) => window.location.href = redirectUrl)
        }

        return {
            getLabel,
            closeOverlay,
            submit,
            privacyPolicy,
            isSubmitting
        }
    }
}